import types from './types';

export const state = {
  emailsList: [],
  numberOfEmails: 0,
  numberOfPages: 1,
  page: 1,
  slug: '',
};

export const mutations = {
  [types.EMAIL_LIST_SET_LIST](state, data) {
    state.emailsList = data.emails;
    state.numberOfPages = data.total_pages;
    state.numberOfEmails = data.total;
  },
  [types.EMAIL_LIST_SET_PAGE](state, page) {
    state.page = page;
  },
  [types.EMAIL_LIST_SET_SLUG](state, slug) {
    state.slug = slug;
  },
};



// WEBPACK FOOTER //
// ./src/screens/Emails/store/mutations.js